import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';

import { useActionDispatcher } from '../../../hooks/index';
import ProjectForm from './ProjectForm';
import {
  createProjectRequest,
  initProjectRequest,
} from '../../../store/modules/projects/actions';
import {
  isProjectPersistent,
  selectProject,
} from '../../../store/modules/projects/selectors';
import SavedSearchService, { SavedSearchPages } from '../../../services/SavedSearchService';
import RouteGetter from '../../../routes/RouteGetter';

const ProjectCreate = () => {
  const dispatch = useDispatch();
  // TODO
  // when switching to another tab, the form is cleared
  useEffect(() => {
    dispatch(initProjectRequest());
  }, [dispatch]);

  const createProject = useActionDispatcher(createProjectRequest);

  const persistent = useSelector(isProjectPersistent);
  const project = useSelector(selectProject);

  useEffect(() => {
    if (persistent) {
      dispatch(push(RouteGetter.get('project').overview(project.data!.id)));
    }
  }, [persistent, project.data, dispatch]);

  return (
    <ProjectForm
      creatingMode
      record={project}
      onSubmit={createProject}
      getTitle={() => SavedSearchService.getValue(SavedSearchPages.Project)}
    />
  );
};

export default ProjectCreate;
